import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';
import { ExpandableConfig } from 'antd/lib/table/interface';
import { TriggerEventHandler } from 'rc-table/lib/interface';

const EXPAND_ICON_SIZE = 20;

export const getExpandableConfig = <T,>(hasChildren: (record: T) => boolean): ExpandableConfig<T> | undefined => ({
    indentSize: 0,
    expandIcon: ({ expanded, onExpand, record }: { expanded: boolean; onExpand: TriggerEventHandler<T>; record: T }) =>
        hasChildren(record) ? (
            <span
                onClick={(e) => {
                    e.stopPropagation();
                    onExpand(record, e);
                }}
                style={{
                    cursor: 'pointer',
                    display: 'inline-block',
                    width: EXPAND_ICON_SIZE,
                    fontSize: EXPAND_ICON_SIZE,
                    lineHeight: 1,
                    userSelect: 'none',
                }}
            >
                {expanded ? (
                    <CaretDownOutlined style={{ color: 'var(--gray-9)' }} />
                ) : (
                    <CaretRightOutlined style={{ color: 'var(--gray-9)' }} />
                )}
            </span>
        ) : (
            <span style={{ display: 'inline-block', width: EXPAND_ICON_SIZE }} />
        ),
});
